export class LocalStorage {
    public static readonly VUEX_PERSIST: string = 'vuex-bo'
}